import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import styles from './WorkflowStepper.module.css';

interface IWorkflowStepperProps {
  current: any;
  onStepClick?: (step: number) => void;
}

const STEPS = [
  {
    title: 'UPLOAD JUSTIFICATION LETTER',
    status: 'pending',
    key: 'UPLOAD'
  },
  {
    title: 'QC REVIEW & SUBMIT TO PORTAL',
    status: 'pending',
    key: 'QC_REVIEW'
  },
  {
    title: 'ANNEXURE (DOWNLOAD/UPLOAD)',
    status: 'pending',
    key: 'ANNEXURE'
  },
  // {
  //   title: 'ANNEXURE REVIEW & SUBMIT TO PORTAL',
  //   status: 'pending',
  //   key: 'FINAL_REVIEW'
  // },
];

const WorkflowStepper: React.FC<IWorkflowStepperProps> = ({ current, onStepClick }) => {
  const getStepStatus = (index: number) => {
    if (current > index) return 'completed';
    if (current === index) return 'inProgress';
    return 'pending';
  };

  const isClickable = (index: number) => {
    return index <= current + 1;
  };

  return (
    <div className={styles.workflowStepperContainer}>
      <div className={styles.stepsWrapper}>
        {STEPS.map((step, index) => {
          const status = getStepStatus(index);
          const clickable = isClickable(index);

          return (
            <div
              key={step.key}
              className={`${styles.stepPill} ${styles[`step-${status}`]} ${clickable ? styles.clickable : ''}`}
              onClick={() => clickable && onStepClick?.(index)}
            >
              <div className={styles.stepContent}>
                {status === 'completed' && (
                  <CheckCircleOutlined className={styles.stepIcon} />
                )}
                {status !== 'completed' && (
                  <span className={styles.stepNumber}>{index + 1}</span>
                )}
                <span className={styles.stepTitle}>{step.title}</span>
              </div>
              <div className={styles.stepSubtitle}>
                {status === 'completed' && 'Completed'}
                {status === 'inProgress' && 'In Progress'}
                {status === 'pending' && 'Pending'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkflowStepper;
